import React, { useState, useEffect } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { removeAlert } from "./../../reducers/userConfigSlice";
// Icons
import { TbSquareRoundedCheck, TbSquareRoundedX, TbAlertSquareRounded, TbInfoSquareRounded } from "react-icons/tb";
// Styles
import "./style.css";

export const Alert = () => {
  const alerts = useSelector((state) => state.aplicationConfig.userConfig.alerts);

  return (
    <div className="alert-container">{alerts && alerts.map((alert, index) => <AlertComponent key={alert.id} alert={alert} index={index + 1} />)}</div>
  );
};

const AlertComponent = ({ alert, index }) => {
  const timeBadge = 3000; // 3 segundos
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    let start = 0;
    const interval = setInterval(() => {
      start += 100 / (timeBadge / 50);
      setProgress(start);
    }, 50);

    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        dispatch(removeAlert(alert.id)); // Eliminar la alerta del estado global
      }, 300); // Pequeño delay para animación
    }, timeBadge);

    return () => {
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, [alert.id, dispatch]); // Dependemos solo de la alerta actual

  const getColor = (type) => {
    switch (type) {
      case "success":
        return "var(--color-success)";
      case "warning":
        return "var(--color-pending)";
      case "error":
        return "var(--color-error)";
      default:
        return "var(--color-process)";
    }
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case "success":
        return <TbSquareRoundedCheck style={{ color: getColor(type) }} />;
      case "error":
        return <TbSquareRoundedX />;
      case "warning":
        return <TbAlertSquareRounded />;
      default:
        return <TbInfoSquareRounded style={{ color: getColor(type) }} />;
    }
  };

  return (
    <div
      className={`alert-banner ${isVisible ? "show" : "hide"}`}
      style={{ bottom: `${index * 70}px` }} // Se apilan verticalmente
    >
      <div className="alert-banner-body">
        <div className="message-icon">{getAlertIcon(alert.type)}</div>
        <div>
          <div className="message-title">{alert.title}</div>
          <div className="message-description">{typeof alert.message === "string" && alert.message}</div>
        </div>
      </div>
      <div id={"progress-line" + index} className="progress-line" style={{ backgroundColor: getColor(alert.type), width: `${progress}%` }}></div>
    </div>
  );
};
